/** StrategyActionTypes.Id for the Email action (see backend StrategyActionTypeIds.Email). */
export const EMAIL_ACTION_TYPE_ID = 1;

export const NO_PRIMARY_CONTACT_WARNING =
  'This customer does not have a primary contact set and automated strategies will create contactless cases where any email action will be skipped.';

export const PRIMARY_CONTACT_NO_EMAIL_WARNING =
  'This customer primary contact does not have an email address and automated strategies will skip any email action.';

/** Minimal shape needed to decide which primary-contact warning the overview shows. */
export interface PrimaryContactState {
  hasPrimaryContact?: boolean;
  primaryContactHasEmail?: boolean;
}

/**
 * Live customer detail always returns both flags; demo data leaves them undefined, so a
 * warning is only produced when the backend explicitly reports the problem.
 */
export function primaryContactWarning(customer: PrimaryContactState | null | undefined): string | null {
  if (customer?.hasPrimaryContact === false) return NO_PRIMARY_CONTACT_WARNING;
  if (customer?.primaryContactHasEmail === false && customer.hasPrimaryContact === true) {
    return PRIMARY_CONTACT_NO_EMAIL_WARNING;
  }
  return null;
}

export const STRATEGY_EMAIL_NO_PRIMARY_CONTACT_WARNING =
  'This strategy includes email actions but this customer has no primary contact set, so those emails will not be sent.';

export const STRATEGY_EMAIL_NO_PRIMARY_CONTACT_BULK_WARNING =
  'This strategy includes email actions but some of the selected customers have no primary contact set, so those emails will not be sent.';

/** Minimal shape needed to decide whether a strategy sends emails. */
export interface EmailActionStrategy {
  hasEmailAction?: boolean;
  actions?: { type: string }[];
}

export function strategyHasEmailAction(strategy: EmailActionStrategy | null | undefined): boolean {
  if (!strategy) return false;
  return strategy.hasEmailAction === true || (strategy.actions?.some((x) => x.type === 'email') ?? false);
}
